/* eslint-disable @typescript-eslint/no-unused-vars */
import { useContext, useEffect, useState } from 'react';
import ComponenteTables from '../../components/tables/ComponentTables/ComponentTables';
import { LoadingContext } from '../../context/Loading/LoadingContext';
import { table } from '../../dados/registros/registros.dado';
import { useApi } from '../../hooks/userApi';
import React from 'react';
import { SelectChangeEvent } from '@mui/material';

const api = useApi();

export default function TableLog() {
  const {
    loading,
    setLoading,
    loadingMensagem,
    setLoadingMensagem,
    loadingBtn,
    setLoadingBtn,
    loadingAction,
    setLoadingAction,
  }: any = useContext(LoadingContext);
  const [dados, setDados] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(Number(process.env.REACT_APP_PAGINATION_DEFAULT) || 15);
  const [pageTotal, setPageTotal] = useState(0);
  const [like, setLike] = useState('all');
  const [selectedFilterColumns, setSelectedFilterColumns] = useState<string[]>([]);

  useEffect(() => {
    setLoading(true);
    api
      .get('/logger' + `?offset=${limit * (page - 1)}&limit=${limit}&like=${like}`)
      .then((response) => {
        if (!response.status) {
          setLoadingMensagem('Desculpe ocorreu um erro!');
          setLoadingBtn('OK');
          return;
        }
        setLoading(false);
        setDados(response.results);
        setPageTotal(response.page_total);
      })
      .catch((e) => {
        let msg = 'Houve um erro interno, tente mais tarde.' + e.message;
        if (e.code === 'ERR_BAD_REQUEST') msg = 'Usuário e/ou senha inválidos';

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
  }, [page, like]);

  const handleLike = (value) => {
    setPage(1);
    setLike(value);
  };

  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  function formatarIdentificador(identificador) {
    const prefixo = identificador.substring(0, 2);
    const sufixo = identificador.substring(identificador.length - 8);
    return `${prefixo}...${sufixo}`;
  }

  function formataTable(objeto) {
    const novoObjeto = objeto.map((row) => {
      try {
        const mensagem = JSON.parse(row?.message);
        return {
          rowCell: [
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            { campo: formatarIdentificador(row?.id) || '-', onClick: () => exibirRelatorio(row), link: true },
            { campo: row?.context + ' | ' + mensagem?.method || '-', onClick: null, link: false },
            { campo: mensagem?.ip || '-', onClick: null, link: false },
            { campo: mensagem?.url || '-', onClick: null, link: false },
            { campo: mensagem?.user || '-', onClick: null, link: false },
            { campo: mensagem?.statusCode || '-', onClick: null, link: false },
            { campo: new Date(row?.created_at || '').toLocaleDateString('pt-br'), onClick: null, link: false },
          ],
        };
      } catch (error) {
        return {
          rowCell: [
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            { campo: formatarIdentificador(row?.id) || '-', onClick: () => exibirRelatorio(row), link: true },
            { campo: row?.context || '-', onClick: null, link: false },
            { campo: '-', onClick: null, link: false },
            { campo: '-', onClick: null, link: false },
            { campo: 'Servidor', onClick: null, link: false },
            { campo: '-', onClick: null, link: false },
            { campo: new Date(row?.created_at || '').toLocaleDateString('pt-br'), onClick: null, link: false },
          ],
        };
      }
    });
    return novoObjeto;
  }

  // Gera uma nova página com todos os detalhes do log
  function exibirRelatorio(logData) {
    const newWindow = window.open('Log', '_blank');
    newWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Detalhes do Log</title>
      </head>
      <body>
        <h1>Detalhes do Log</h1>
        <p><strong>ID:</strong> ${logData?.id}</p>
        <p><strong>Context:</strong> ${logData?.context}</p>
        <p><strong>Mensagem:</strong></p>
        <pre>${JSON.stringify(JSON.parse(logData?.message), null, 2)}</pre>
        <p><strong>Nível:</strong> ${logData?.level}</p>
        <p><strong>Data de Criação:</strong> ${new Date(logData?.created_at).toLocaleString()}</p>
      </body>
      </html>
    `);
  }

  const arrList = {
    header: table.header,
    type: table.type,
    rows: formataTable(dados),
  };

  const handleFilterColumnsChange = (event: SelectChangeEvent<typeof selectedFilterColumns>) => {
    setSelectedFilterColumns(event.target.value as string[]);
  };

  return (
    <ComponenteTables
      table={arrList}
      cadastro={null}
      pageTotal={pageTotal}
      page={page}
      handleChangePage={handleChangePage}
      handleLike={handleLike}
      selectedFilterColumns={selectedFilterColumns}
      handleFilterColumnsChange={handleFilterColumnsChange}
    />
  );
}
